import { useState } from 'react'
import { useTheme } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import cn from 'classnames'
import styles from './VNButtonContainer.module.scss'

/**
 * @param {Function} onClick Handle the onClick event.
 * @param {style} buttonStyle style to be applied to the button
 * @param {style} containerStyle style to be applied to the container
 * @param {Boolean} defaultSelected if no buttons are selected the first will be selected
 * @param {Array} buttons a 2d array of objects. Each nested array's length will be how many buttons show up in a row.
 * inside of the nested array will contain objects, these objects are used for styling that specific button.
 *      @param {String} buttonVariant the style that is in the mui theme
 *      @param {String} padding padding around object
 *      @param {String} title title of each object
 *      @param {String} id the id that will be returned to the user when an object is clicked.
 *      @param {Boolean} selected the first one to be selected.
 */
export const VNButtonContainer = (props) => {
  const [selected, setSelected] = useState(props.defaultSelected ? '0-0' : null)
  const [defaultSelected, setDefaultSelected] = useState(false)
  const buttons = {}
  const theme = useTheme()

  const renderArray = () => {
    return props.buttons.map((nestedButtons, xIndex) => {
      return (
        <div className={cn(styles.container, props?.containerStyle)} key={`row-${xIndex}`}>
          {nestedButtons.map((button, yIndex) => {
            if (button?.selected && !defaultSelected) {
              setDefaultSelected(true)
              setSelected(`${xIndex}-${yIndex}`)
            }
            buttons[`${xIndex}-${yIndex}`] = selected === `${xIndex}-${yIndex}` ? true : false
            return (
              <div
                key={`${xIndex}-${yIndex}`}
                id={`${xIndex}-${yIndex}`}
                className={styles.buttonParent}
                style={{ padding: button.padding ? button.padding : theme.custom.defaultPadding }}
              >
                <Button
                  color={'secondary'}
                  onClick={() => {
                    if (props.disabled) return
                    setSelected(`${xIndex}-${yIndex}`)
                    props.onClick(button)
                  }}
                  disableRipple={button.disableRipple ? button.disableRipple : false}
                  style={theme.custom[button.buttonVariant]}
                  className={cn(styles.containerButton, props?.buttonStyle, { [button?.style]: button?.style })}
                  variant={buttons[`${xIndex}-${yIndex}`] ? 'contained' : 'outlined'}
                  fullWidth={false}
                >
                  {button.title}
                </Button>
              </div>
            )
          })}
        </div>
      )
    })
  }

  return renderArray()
}
